/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import analytics from "analytics/analytics";
import browser from "../../utils/browser";
import globals from "modules/globals";

function onClick(event) {
    let href = this.el.href;
    let target = this.el.target;

    let category = this.options.eventCategory;
    let action = this.options.eventAction;
    let label = this.options.eventLabel;

    if (_.isString(category) && _.isString(action) && href) {
        let newTab =
            (browser.mac && event.metaKey) || (!browser.mac && event.ctrlKey) || event.which === 2;

        if (target === "_blank" || newTab) {
            analytics.event(category, action, label);
        } else {
            event.preventDefault();
            analytics.event(category, action, label).then(() => {
                globals.window.location = href;
            });
        }
    }
}

export default {
    defaultOptions: {
        eventCategory: null,
        eventAction: null,
        eventLabel: null
    },

    setupEvents(add) {
        add("click", onClick);
    }
};

